/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VisibilityConditionNode } from './VisibilityConditionNode';
import {
    VisibilityConditionNodeFromJSON,
    VisibilityConditionNodeFromJSONTyped,
    VisibilityConditionNodeToJSON,
    VisibilityConditionNodeToJSONTyped,
} from './VisibilityConditionNode';

/**
 * Root-level visibility condition group containing child conditions
 * @export
 * @interface VisibilityConditionGroup
 */
export interface VisibilityConditionGroup {
    /**
     * Logical operator to combine conditions
     * @type {string}
     * @memberof VisibilityConditionGroup
     */
    operator?: VisibilityConditionGroupOperatorEnum | null;
    /**
     * List of child conditions (can be leaves or nested groups)
     * @type {Array<VisibilityConditionNode>}
     * @memberof VisibilityConditionGroup
     */
    conditions?: Array<VisibilityConditionNode> | null;
}


/**
 * @export
 */
export const VisibilityConditionGroupOperatorEnum = {
    And: 'AND',
    Or: 'OR'
} as const;
export type VisibilityConditionGroupOperatorEnum = typeof VisibilityConditionGroupOperatorEnum[keyof typeof VisibilityConditionGroupOperatorEnum];


/**
 * Check if a given object implements the VisibilityConditionGroup interface.
 */
export function instanceOfVisibilityConditionGroup(value: object): value is VisibilityConditionGroup {
    return true;
}

export function VisibilityConditionGroupFromJSON(json: any): VisibilityConditionGroup {
    return VisibilityConditionGroupFromJSONTyped(json, false);
}

export function VisibilityConditionGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisibilityConditionGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'operator': json['operator'] == null ? undefined : json['operator'],
        'conditions': json['conditions'] == null ? undefined : ((json['conditions'] as Array<any>).map(VisibilityConditionNodeFromJSON)),
    };
}

export function VisibilityConditionGroupToJSON(json: any): VisibilityConditionGroup {
    return VisibilityConditionGroupToJSONTyped(json, false);
}

export function VisibilityConditionGroupToJSONTyped(value?: VisibilityConditionGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operator': value['operator'],
        'conditions': value['conditions'] == null ? undefined : ((value['conditions'] as Array<any>).map(VisibilityConditionNodeToJSON)),
    };
}

